import React, { useCallback, useEffect, useState } from "react";

import { Tooltip } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import InfoIcon from "@mui/icons-material/Info";
import { GaugeMeter } from "../../../shared";
import { AverageFaceEmoji, HappyFaceEmoji, NoEmotionsFaceEmoji, SadEmotionFaceEmoji } from "../../../../assets";
import { useHistory } from "react-router-dom";

const healthTrackerStatus = {
	danger: {
		emoji: SadEmotionFaceEmoji,
		message: {
			main: "Danger Zone!",
			subText: "Critical health issues. Consult a professional."
		}
	},
	bad: {
		emoji: NoEmotionsFaceEmoji,
		message: {
			main: "Not Good!",
			subText: "Health concerns needing attention."
		}
	},
	average: {
		emoji: AverageFaceEmoji,
		message: {
			main: "Average!",
			subText: "Okay, but room for improvement."
		}
	},
	good: {
		emoji: HappyFaceEmoji,
		message: {
			main: "Thats Awesome!",
			subText: "It appears that you are doing well."
		}
	}
};

import "./personalHealthTracker.css";

type PersonalHealthTrackerProp = {
	healthScore: number;
	handleOpenPersonalHealthScoreModalClick: (modal: "CURRENT" | "HISTORY") => void;
};

const PersonalHealthTracker: React.FC<PersonalHealthTrackerProp> = ({
	healthScore,
	handleOpenPersonalHealthScoreModalClick
}): JSX.Element => {
	const [healthScoreStatus, setHealthScoreStatus] = useState({
		emoji: "",
		message: {
			main: "",
			subText: ""
		}
	});
	const navigate = useHistory();

	const handleSetHealthScore = useCallback((healthScore: number) => {
		if (healthScore < 21) setHealthScoreStatus(healthTrackerStatus.danger);
		if (healthScore < 41 && healthScore >= 21) setHealthScoreStatus(healthTrackerStatus.bad);
		if (healthScore < 61 && healthScore >= 41) setHealthScoreStatus(healthTrackerStatus.average);
		if (healthScore <= 100 && healthScore >= 61) setHealthScoreStatus(healthTrackerStatus.good);
	}, []);

	useEffect(() => {
		healthScore && handleSetHealthScore(healthScore);
	}, [handleSetHealthScore, healthScore]);

	return (
		<div className="personal-health-tracker-main-container">
			<h3>My Health Score</h3>
			<div className="gauge-component">
				<GaugeMeter width="auto" healthScore={healthScore} />
			</div>
			<div className="status-container">
				<div className="status-emoji">
					<img src={healthScoreStatus.emoji} alt="" />
				</div>
				<div className="status-message">
					<span className="main-message">{healthScoreStatus.message.main}</span>
					<span className="sub-message">{healthScoreStatus.message.subText}</span>
				</div>
			</div>
			<div className="button-group-container">
				<Tooltip title="Previous Records">
					<button className="option-btn" onClick={() => handleOpenPersonalHealthScoreModalClick("HISTORY")}>
						<HistoryIcon style={{ color: "#5e2dce" }} />
					</button>
				</Tooltip>

				<button className="take-test-button" onClick={() => navigate.push("/personal-health-test")}>
					Take a Test
				</button>
				<Tooltip title="Detailed Insight">
					<button className="option-btn" onClick={() => handleOpenPersonalHealthScoreModalClick("CURRENT")}>
						<InfoIcon style={{ color: "#5e2dce" }} />
					</button>
				</Tooltip>
			</div>
		</div>
	);
};

export default PersonalHealthTracker;
